import {
    DetectionClass,
    getClassTranslationKey,
} from '@/utils/detection-classes';

export interface ObjectClass {
    id: number;
    name: string;
}

export interface ObjectCategory {
    id: string;
    name: string;
    classes: ObjectClass[];
}

function objectClass(detectionClass: DetectionClass): ObjectClass {
    return {
        id: detectionClass,
        name: getClassTranslationKey(detectionClass),
    };
}

export const STANDALONE_CLASSES: ObjectCategory[] = [
    {
        id: 'person',
        name: getClassTranslationKey(DetectionClass.Person),
        classes: [DetectionClass.Person, DetectionClass.Child].map(objectClass),
    },
];

export const OBJECT_CATEGORIES: ObjectCategory[] = [
    {
        id: 'vehicles',
        name: 'vehicles',
        classes: [
            DetectionClass.Motorcycle,
            DetectionClass.EScooter,
            DetectionClass.Bicycle,
            DetectionClass.Micromobility,
            DetectionClass.CarVan,
            DetectionClass.Pickup,
            DetectionClass.ThreeWheeler,
            DetectionClass.Bus,
            DetectionClass.Truck,
            DetectionClass.Trailer,
            DetectionClass.RailVehicle,
            DetectionClass.Airplane,
            DetectionClass.Helicopter,
            DetectionClass.Drone,
            DetectionClass.Boat,
            DetectionClass.HeavyMachinery,
        ].map(objectClass),
    },
    {
        id: 'weapons',
        name: 'weapons',
        classes: [
            DetectionClass.Handgun,
            DetectionClass.RifleLongGun,
            DetectionClass.Knife,
            DetectionClass.BluntWeapon,
        ].map(objectClass),
    },
    {
        id: 'electronics',
        name: 'electronics',
        classes: [
            DetectionClass.ScreenMonitor,
            DetectionClass.Laptop,
            DetectionClass.HandheldDevice,
            DetectionClass.Camera,
        ].map(objectClass),
    },
    {
        id: 'bags',
        name: 'bags',
        classes: [
            DetectionClass.Backpack,
            DetectionClass.DuffelBag,
            DetectionClass.Handbag,
            DetectionClass.Suitcase,
        ].map(objectClass),
    },
    {
        id: 'animals',
        name: 'animals',
        classes: [
            DetectionClass.Cat,
            DetectionClass.Dog,
            DetectionClass.Horse,
        ].map(objectClass),
    },
    {
        id: 'belongings',
        name: 'belongings',
        classes: [
            DetectionClass.Bottle,
            DetectionClass.Cup,
            DetectionClass.Box,
            DetectionClass.Crate,
            DetectionClass.LongCarriedObject,
            DetectionClass.HandheldTool,
        ].map(objectClass),
    },
    {
        id: 'mobilityAids',
        name: 'mobilityAids',
        classes: [DetectionClass.Stroller, DetectionClass.Wheelchair].map(
            objectClass,
        ),
    },
    {
        id: 'hazards',
        name: 'hazards',
        classes: [DetectionClass.Fire, DetectionClass.Smoke].map(objectClass),
    },
];

export const OBJECT_CLASSES: ObjectClass[] = [
    ...STANDALONE_CLASSES.flatMap((category) => category.classes),
    ...OBJECT_CATEGORIES.flatMap((category) => category.classes),
];
